import React from "react";

const InstagramIcon: React.FC = () => (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6406 0H5.14062C2.52836 0 0.390625 2.02432 0.390625 4.5V13.5C0.390625 15.9748 2.52836 18 5.14062 18H14.6406C17.2529 18 19.3906 15.9748 19.3906 13.5V4.5C19.3906 2.02432 17.2529 0 14.6406 0ZM10.3906 12C8.18123 12 6.39062 10.4325 6.39062 8.5001C6.39062 6.56683 8.18123 5 10.3906 5C12.5991 5 14.3906 6.56683 14.3906 8.5001C14.3906 10.4325 12.5991 12 10.3906 12ZM13.3906 4C13.3906 4.5522 13.8378 5 14.3906 5C14.9434 5 15.3906 4.5522 15.3906 4C15.3906 3.4478 14.9434 3 14.3906 3C13.8378 3 13.3906 3.4478 13.3906 4Z"
        fill="currentColor"
      />
    </svg>
  );

export default InstagramIcon;
